export * from "./campaign-config.js";
